<template>
  <v-form>
    <v-container v-if="loading">
      <div class="text-xs-center">
        <v-progress-circular indeterminate :size="150" :width="8" color="green"></v-progress-circular>
      </div>
    </v-container>
    <v-container v-else>
      <div style="height: 10px;"></div>
      <v-layout row wrap>
        <v-flex xs12>
          <v-text-field
            label="商品データファイル"
            @click="pickFile"
            v-model="fileName"
            prepend-icon="attach_file"
            hint="CSVファイル"
            readonly
            v-validate="'required'"
            data-vv-name="uploadFile"
            :error-messages="errors.collect('uploadFile')"
          ></v-text-field>
          <input
            type="file"
            ref="file"
            style="display: none"
            accept=".csv,text/csv"
            @change="onFileChange"
          />
          
          <v-btn block color="success" dark :loading="loading1" :disabled="loading1" @click="fileUpload()">
            <v-icon dark left>cloud_upload</v-icon>アップロード実行
          </v-btn>
        </v-flex>

        <v-flex xs12 sm6>
          <v-select
            v-model="selectCategory"
            :items="itemCategories"
            label="商品カテゴリ"
            item-text="itemCategoryName"
            item-value="itemCategoryId"
            :sort-by="['itemCategoryId']"
            :sort-desc="[false]"
            return-object
          ></v-select>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 sm6>
          <v-switch label="廃番商品も表示する" color="info" value="info" hide-details v-model="dispDeleted"></v-switch>
        </v-flex>
      </v-layout>
      <div style="height: 20px;"></div>

      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        hide-actions
        :customFilter="customFilter"
        :search="selectCategory"
        :custom-sort="customSort"
      >
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">{{ props.header.text }}</span>
            </template>
            <span>{{ props.header.text }}</span>
          </v-tooltip>
        </template>
        <template v-slot:items="props">
          <tr 
            v-if="dispDeleted === 'info' || (dispDeleted !== 'info' && '0' === props.item.isDeleted) || '1' === props.item.displayOnScreen "
            v-bind:class="{
              'deleted-class-name': props.item.isDeleted == '1' ? true : false,
              'invisible-class-name': props.item.displayOnScreen == '1' ? true : false,
              'changed-class-name': props.item.isChanged
            }"
          >
            <td class="text-xs-left" @click="forwardItemEdit(props.item)">{{ props.item.itemCategoryName }}</td>
            <td class="text-xs-left" @click="forwardItemEdit(props.item)">{{ props.item.itemName }}</td>
            <td class="text-xs-left" @click="forwardItemEdit(props.item)">{{ props.item.janCode }}</td>
            <td class="text-xs-right" @click="forwardItemEdit(props.item)">{{ Number(props.item.unitPrice || 0).toLocaleString() }}</td>
            <td class="text-xs-right">
              <input
                type="number"
                categoryName="numberOfStocks[]"
                v-model="props.item.numberOfStocks"
                min="0"
                class="column-input"
                style="width: 100% !important;"
                @change="onChangeStock(props.item)"
              />
            </td>
            <td class="text-xs-right">
              <input
                type="number"
                categoryName="numberOfStocks[]"
                v-model="props.item.orderLimitNumber"
                min="0"
                class="column-input"
                style="width: 100% !important;"
                @change="onChangeOrderLimit(props.item)"
              />
            </td>
          </tr>
        </template>
      </v-data-table>
      <br />

      <!-- 버튼 영역 -->
      <div class="footer-btns">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
        <v-btn
          block
          color="primary"
          dark
          :loading="downloading"
          :disabled="downloading"
          @click="downloadItemsCsv()"
        >
          <v-icon dark left>get_app</v-icon>
          {{ $t('download-btn') }}
        </v-btn>
        <v-btn block class="ma-2" :loading="loading2" :disabled="loading2" color="error" @click="updateItems()">
          <v-icon dark left>save</v-icon>データ一括更新
        </v-btn>
        <v-btn block color="success" dark :to="{ name: 'admin/new-item-regist', params: { category: 'dummy' }}">
          <v-icon dark left>create</v-icon>新規登録
        </v-btn>
      </div>
    </v-container>
  </v-form>
</template>

<script>
import { mapState } from 'vuex'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'
export default {
  created() {
    console.log('created')

    this.getAllItems()
  },
  methods: {
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (a.itemCategoryId < b.itemCategoryId) {
          return -1
        } else if (a.itemCategoryId > b.itemCategoryId) {
          return 1
        }
        if (a.itemName < b.itemName) {
          return -1
        } else if (a.itemName > b.itemName) {
          return 1
        }
        return 0
      })
      return items
    },
    onChangeStock(changedItem) {
      console.log('change stock')
      changedItem.isChanged = true
    },
    onChangeOrderLimit(changedItem) {
      console.log('change order limit')
      changedItem.isChanged = true
    },
    updateItems() {
      console.log('update item dialog')
      let thisObj = this

      let filteringItems = this.items.filter(function(value) {
        if (value.isChanged == true) {
          return true
        } else {
          return false
        }
      })

      if (filteringItems.length === 0) {
        this.$parent.$parent.$parent.showErrorDialog(
          '一括更新対象の商品が選択されていません'
        )
        this.loading2 = false
        return
      }

      ServerApiCallService.itemsUpdateStock(filteringItems)
        .then(() => {
          console.log('completed stock update ')
          this.loading2 = false
          // 変更フラグの初期化
          this.items.forEach(item => {
            item.isChanged = false
          })
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
        .finally(() => {
          this.loading2 = false
        })
    },
    async getAllItems() {
      this.loading = true
      try {
        const [catRes, itemRes] = await Promise.all([
          ServerApiCallService.itemCategories(),
          ServerApiCallService.items()
        ])

        const categories = catRes.data.itemCategories.filter(c => c.status === '1')
        categories.unshift({ itemCategoryId: '#', itemCategoryName: '全て' })
        this.itemCategories = categories
        this.items = itemRes.data.items.map(item => ({ ...item, isChanged: false })) 
      } catch (error) {
        console.log('There was an error:', error.response)
      } finally {
        this.loading = false
      }
    },
    customFilter(items, search) {
      if (search.itemCategoryName === '全て') {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemCategoryId === search.itemCategoryId) {
            return true
          } else {
            return false
          }
        })

        return filteringItems
      }
    },    
    forwardItemEdit(itemInfo) {
      this.$router.push({
        name: 'admin_items_update',
        params: { itemCode: itemInfo.itemCode }
        // params: { itemInfo: itemInfo, category: this.category }
      })
    },
    pickFile() {
      this.$refs.file.value = ''   // 같은 파일을 다시 골라도 change가 발생하도록
      this.$refs.file.click()
    },
    onFileChange(e) {
      const file = e.target.files && e.target.files[0]
      if (!file) return            // 취소한 경우 기존 선택을 유지
      
      if (!/\.csv$/i.test(file.name)) {
        this.$parent.$parent.$parent.showErrorDialog('CSVファイルを選択してください')
        e.target.value = ''
        return
      }

      this.targetFile = file
      this.fileName = file.name
    },
    resetFile() {
      this.targetFile = null
      this.fileName = ''
      if (this.$refs.file) this.$refs.file.value = ''
      this.$validator.reset()
    },
    async fileUpload() {

      // ① 업로드 중이면 중복 실행 방지
      if (this.loading1) {
        return
      }

      // ② 업로드 시작 상태 설정
      this.loading1 = true

      try {
        const valid = await this.$validator.validateAll()

        if (!valid || !this.targetFile) {
          this.$parent.$parent.$parent.showErrorDialog(this.$t('hasInputError'))
          return
        }

        const formData = new FormData()
        formData.append('uploadFile', this.targetFile)
        formData.append('charsetName', this.fileFormat)

        const response = await ServerApiCallService.sendItemsFile(formData, {
          hasDialogComponent: this.$parent.$parent.$parent
        })

        // 서버에서 업무 처리 실패를 반환한 경우
        if (String(response.data.result) === '1') {
          return
        }

        this.resetFile()
        await this.getAllItems()

      } catch (error) {
        console.error('商品CSVアップロード失敗', error)

      } finally {
        // 업로드 완료 또는 실패 시 해제
        this.loading1 = false
      }
    },

    downloadItemsCsv() {

      // 1. 다운로드 중이면 중복 실행 방지
      if (this.downloading) {
        return
      }

      // 2. 다운로드 시작
      this.downloading = true
      
      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .get('/admin/items-download', {
          responseType: 'blob'
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')

          let url = window.URL.createObjectURL(blob)

          link.href = url
          link.download = '商品一覧.csv'
          link.click()

          // Blob URL 메모리 해제
          setTimeout(() => {
            window.URL.revokeObjectURL(url)
          }, 1000)

        })
        .catch(error => {
          console.error('CSV 다운로드 실패:', error)
        })
        .finally(() => {
          // 다운로드 완료 또는 실패 시 해제
          this.downloading = false
        })
     }
  },
  computed: {
    ...mapState({
      user: state => state.admin
    }),
    selectCategory: {
      get() {
        return this.$store.state.adminSession.selectCategory
      },
      set(value) {
        this.$store.commit('SET_SELECTED_ITEM_CATEGORY', value)
      }
    }
  },
  data() {
    return {
      loader: null,
      loading: true,
      loading1: false,
      loading2: false,
      downloading: false, //CSV 다운로드가 진행 중인지 관리하는 변수
      dispDeleted: 'info',
      items: [],
      itemCategories: [],

      targetFile: null,
      fileName: '',
      fileFormat: 'Windows-31J',

      headers: [
        {
          text: 'カテゴリ',
          align: 'left',
          value: 'itemCategoryName',
          width: '150px',
          sortable: false
        },
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '150px',
          sortable: false
        },
        {
          text: 'JANコード',
          align: 'left',
          value: 'janCode',
          width: '30px',
          sortable: false
        },
        {
          text: '単価',
          align: 'center',
          value: 'unitPrice',
          width: '30px',
          sortable: false
        },
        {
          text: '在庫数',
          align: 'center',
          value: 'numberOfStocks',
          width: '100px',
          sortable: false
        },
        {
          text: '発注制限数',
          align: 'center',
          value: 'orderLimitNumber',
          width: '100px',
          sortable: false
        }
      ]
    }
  }
}
</script>

<style>
.column-input {
  width: 100% !important;
  height: 30px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
}

.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.invisible-class-name {
  background-color: #b3e460;
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
